var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-items"},_vm._l((_vm.tabList),function(item){return _c('div',{key:item.id,staticClass:"tab-item",class:[
      !_vm.isPerson && item.id == 6
        ? ("tab-item-" + (item.id) + " no-display")
        : ("tab-item-" + (item.id)) ],on:{"click":function($event){return _vm.clickHandler(item)}}},[_c('span',{staticClass:"icon",style:({ backgroundImage: ("url(" + (item.icon) + ")") })}),(
        item.id == 4 &&
          _vm.isLogin &&
          _vm.checkStatus == _vm.CHECK_STATUS.GETTED &&
          (!_vm.noVerifi || !_vm.isPerson)
      )?_c('input',{ref:"uploadEl",refInFor:true,attrs:{"type":"file"},on:{"change":_vm.onChange,"click":function($event){$event.stopPropagation();}}}):_vm._e(),_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.name))]),_c('span',{staticClass:"bg",style:({ backgroundImage: ("url(" + (item.bg) + ")") })})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }